import React, { useEffect, useMemo, useState, } from 'react';
import { ButtonTypeDLS, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, TextAlignTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import { ActivityIndicator, View, } from 'react-native';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import CustomHeader from "../../customHeader/CustomHeader";
import NeedHelpDC from "../NeedHelpDC";
import { SecureWithUs } from '../../bottomBarDLS/bottomBarTemplate';
import Button from '../../button/Button';
import Typography from '../../typography/Typography';
import Divider from '../../divider/Divider';
import OtpModalScreenDc from '../OtpModalScreenDc';
import Icon from '../../icon/Icon';
const MfdShareLinkInitPage = ({ height, contactUsDetails, details, initAction, caption, otpState = InputStateToken.DEFAULT, handleCloseOtpModalAction, handleTextChangeOtpAction, otpLimitExceeded, verifyAction, initActionData, showOtpModal = false, verifyActionData, linkExpired = false, navNextToStepper, showEndJourney = false, triggerAction, }) => {
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const [customerDetails, setCustomerDetails] = useState(null);
    const [btnLoading, setbtnLoader] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [inputActionData, setInputActionData] = useState();
    const [_showOtpModal, setShowOtpModal] = useState(false);
    const [_linkExpired, setLinkExpired] = useState(false);
    const [otpDigits, setOtpDigit] = useState(0);
    useEffect(() => {
        setShowOtpModal(showOtpModal);
    }, [showOtpModal]);
    useEffect(() => {
        setCustomerDetails(details);
    }, [details]);
    useEffect(() => {
        setLinkExpired(linkExpired);
    }, [linkExpired]);
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    const headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { title: '', hideGoBack: true, triggerAction: triggerAction, needHelpAction: handleNeedHelp, showNeedHelpNewArch: true }));
    }, []);
    const renderCustomerDetails = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(View, { style: { backgroundColor: '#FFF', borderWidth: 1, borderColor: '#F1F3F5', borderRadius: 6, paddingHorizontal: 12, paddingVertical: 16 } },
                React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(View, { style: { width: 150 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Applicant name', color: ColorTokens.Grey_Charcoal })),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: `${customerDetails?.name ? customerDetails?.name : ''}` })),
                React.createElement(View, { style: { marginVertical: 16 } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(View, { style: { width: 150 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Mobile number', color: ColorTokens.Grey_Charcoal })),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: `${customerDetails?.maskedPhone ? customerDetails?.maskedPhone : ''}` })),
                React.createElement(View, { style: { marginVertical: 16 } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                customerDetails?.platform &&
                    React.createElement(React.Fragment, null,
                        React.createElement(View, { style: {
                                flexDirection: 'row'
                            } },
                            React.createElement(View, { style: { width: 150 } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Platform name', color: ColorTokens.Grey_Charcoal })),
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: `${customerDetails?.platform}` })),
                        React.createElement(View, { style: { marginVertical: 16 } },
                            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }))),
                React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(View, { style: { width: 150 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Lender', color: ColorTokens.Grey_Charcoal })),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: `${customerDetails?.lender ? customerDetails?.lender : ''}` })))));
    };
    const renderContent = () => {
        return (React.createElement(View, { style: {
                paddingTop: 24,
                paddingHorizontal: 16
            } },
            React.createElement(Typography, { label: 'Complete your application for loan against mutual funds', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, fontWeight: '600' }),
            React.createElement(View, { style: { height: 8 } }),
            React.createElement(Typography, { label: 'Your funds are only a few steps away!', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
            React.createElement(View, { style: { height: 24 } }),
            renderCustomerDetails()));
    };
    const renderBottom = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(View, { style: { padding: 16, borderTopColor: '#E4E7EC', borderTopWidth: 1 } },
                React.createElement(SecureWithUs, null),
                React.createElement(View, { style: { height: 8 } }),
                React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, height: 40, label: 'Proceed to selfie verification', loading: btnLoading, onPress: async () => {
                        await setbtnLoader(true);
                        initAction &&
                            await triggerAction(initAction);
                        await setbtnLoader(false);
                    } }))));
    };
    useEffect(() => {
        if (initActionData) {
            setOtpDigit(initActionData?.noOfDigits);
        }
    }, [initActionData]);
    const renderOtp = useMemo(() => (React.createElement(OtpModalScreenDc, { showOtpModal: _showOtpModal, setShowOtpModal: setShowOtpModal, caption: caption, state: otpState, title: `Enter ${otpDigits}-digit OTP`, subTitle: 'OTP sent to', charLimit: otpDigits, value: `${customerDetails?.maskedPhone}`, iconUrl: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/icon_holder.png', onChangeText: () => {
            handleTextChangeOtpAction &&
                triggerAction(handleTextChangeOtpAction);
        }, 
        //USER TYPING THE OTP
        action: async (text) => {
            setInputValue(text);
            await triggerAction({
                ...verifyAction,
                payload: {
                    ...verifyAction.payload,
                    requestValue: text,
                    stepId: customerDetails?.currentStepId
                },
            });
        }, 
        //RESEND + OTP INNITIATE (6 DIGIT)
        otpAction: async () => {
            // await triggerAction({
            //     ...verifyAction,
            //     payload: {
            //         ...verifyAction.payload,
            //         requestValue : inputValue
            //     },
            // });
            initAction &&
                await triggerAction(initAction);
        }, handleCloseOtpModal: async () => {
            handleCloseOtpModalAction &&
                await triggerAction(handleCloseOtpModalAction);
        }, triggerAction: triggerAction, useNewBottomSheet: true })), [
        otpState,
        _showOtpModal,
        showOtpModal,
        caption,
        otpLimitExceeded,
        initActionData
    ]);
    const renderExpired = () => (React.createElement(View, { style: {
            height: height ? height - 200 : 200,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 12
        } },
        React.createElement(Icon, { name: IconTokens.SystemError, size: IconSizeTokens.XXXXXXXL }),
        React.createElement(View, { style: { height: 24 } }),
        React.createElement(Typography, { label: 'Link has expired', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, fontWeight: '600' }),
        React.createElement(View, { style: { height: 16 } }),
        React.createElement(View, { style: { backgroundColor: '#FFF6DD', padding: 12, borderRadius: 8 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Please request for a new link to complete your application', textAlign: TextAlignTokens.center }))));
    const renderAfterStepCompletion = () => {
        return (React.createElement(View, { style: {
                height: height ? height - 200 : 200,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                paddingLeft: 12,
                paddingRight: 12
            } },
            React.createElement(View, { style: { borderWidth: 1, borderColor: '#E4E7EC', borderRadius: 8, display: 'flex', flexDirection: 'column' } },
                React.createElement(View, { style: { padding: 12, borderTopLeftRadius: 8, borderTopRightRadius: 8 } },
                    React.createElement(Icon, { name: IconTokens.MFD_IMAGE_1, size: IconSizeTokens.LARGE_DLS }),
                    React.createElement(View, { style: { height: 12 } }),
                    React.createElement(Typography, { label: 'Do you want to continue your loan application journey?', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '600' }),
                    React.createElement(View, { style: { height: 16 } }),
                    React.createElement(Button, { typeDLS: ButtonTypeDLS.SECONDARY, label: 'Continue loan application', height: 40, onPress: () => {
                            navNextToStepper &&
                                triggerAction(navNextToStepper);
                        } })),
                React.createElement(View, { style: { backgroundColor: '#E7EBFA', padding: 12, display: 'flex', flexDirection: 'row', alignItems: 'center', borderBottomLeftRadius: 8, borderBottomRightRadius: 8 } },
                    React.createElement(View, { style: {
                            width: 30
                        } },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_INFO_DLS, size: IconSizeTokens.SMALL_DLS })),
                    React.createElement(View, { style: {
                            flex: 1
                        } },
                        React.createElement(Typography, { label: 'Close the tab if selfie verification is the only step you wanted to complete', typeDLS: TypographyTypeDLS.B2R }))))));
    };
    if (showEndJourney !== true &&
        !customerDetails &&
        !_linkExpired)
        return (React.createElement(View, { style: {
                display: 'flex',
                height: height,
                justifyContent: 'center',
                alignItems: 'center'
            } },
            React.createElement(ActivityIndicator, null)));
    return (React.createElement(BoilerPlate, { height: height, headerChild: headerChild, scrollEnabled: showNeedHelp ? false : true, bottomChildren: React.createElement(React.Fragment, null,
            showEndJourney
                ? React.createElement(View, null)
                : _linkExpired
                    ? React.createElement(View, null)
                    : React.createElement(View, null,
                        renderBottom(),
                        _showOtpModal &&
                            renderOtp),
            showNeedHelp &&
                React.createElement(View, { style: { paddingBottom: 12 } },
                    React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails }))), backgroundColor: ColorTokens.White },
        React.createElement(React.Fragment, null, showEndJourney
            ? renderAfterStepCompletion()
            : _linkExpired
                ? renderExpired()
                : renderContent())));
};
export default MfdShareLinkInitPage;
